module.exports = __webpack_public_path__ + "img/Group 52.73d10358.png";